import React from "react";
import logger from "logger";
import { getStyleJSON } from "Utils/Common";
import TaskInput from "TaskDialogCommon/TaskInput";

export const MapCoordInput = (props) => {
  const { label, paramX, paramY, taskConfig, setValue } = props;
  return (
    <div style={{ padding: "7px" }}>
      <div>{label}</div>
      <div
        style={getStyleJSON(
          "padding-top: 10px;display: inline-flex;"
        )}
        className="fullWidth"
      >
        <div
          style={getStyleJSON(
            "display: inline-flex;"
          )}
          className="fullWidth"
        >
          <div
            style={getStyleJSON(
              "max-width: 50px;display: flex;justify-content: center;align-items: center;"
            )}
          >
            <span style={{ padding: "10px" }}>X:</span>
          </div>
          <div>
            <TaskInput
              placeholder="X"
              value={taskConfig[paramX]}
              onChange={(event) => {
                setValue(event, paramX);
              }}
              type="number"
            />
          </div>
        </div>
        <div
          style={getStyleJSON(
            "display: inline-flex"
          )}
          className="fullWidth"
        >
          <div
            style={getStyleJSON(
              "max-width: 50px;display: flex;justify-content: center;align-items: center;"
            )}
          >
            <span style={{ padding: "10px" }}>Y:</span>
          </div>
          <div>
            <TaskInput
              placeholder="Y"
              value={taskConfig[paramY]}
              onChange={(event) => {
                setValue(event, paramY);
              }}
              type="number"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
